import { FcGoogle } from 'react-icons/fc';
import AcademiaLinkButton from '../CommonComps/Buttons/AcademiaLinkButton';

const SocialLogins = () => {
  // rendering social logins component here
  return (
    <div className='mt-5 pt-5 border-t-2 border-base-light-blue'>
      <AcademiaLinkButton
        href={`${process.env.REACT_APP_USER_SERVICE_PROD_API}/login/`}
        inverted
      >
        <FcGoogle className='size-6' />
        <span>Log In With Google</span>
      </AcademiaLinkButton>
    </div>
  );
};

export default SocialLogins;
